export const TYPES = { // eslint-disable-line import/prefer-default-export
    CANCEL: 'CANCEL',
    VOID: 'VOID',
};
